/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  topPanel: {
    backgroundColor: theme.palette.grey['50'],
    padding: theme.spacing(1, 2),
    marginBottom: Tokens.spacing['$sp-4']
  },
  searchContainer: {
    borderBottomStyle: 'solid',
    borderBottomWidth: Tokens.spacing['$sp-0-25'],
    borderBottomColor: theme.palette.text.secondary
  },
  addButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }
}));
